import React, { useCallback, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import Page from "@smpu-web/globalmodules/page"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import Amount from "@smpu-web/nested/form/amount"
import RadioGroup from "@bappweb/radiogroup"
import Radio from "@bappweb/radio"
import Slider from "@bappweb/slider"
import Element from "@bappweb/element"
import Button from "@bappweb/button"
import FormMessage from "@smpu-web/globalmodules/form-message"
import CalculationDetail from "./calculationdetail"
import { useGetProductInfoMutation, useStartApplicationMutation } from "../../../api/services"
import { calculateMonthlyPayment } from "@smpu-web/utils/calculateinterest"
import { useAppDispatch } from "../../../config/hook"
import { setCustomerData } from "../../../state/customerdata"
import "../assets/style.scss"

const VEHICLE_TYPE_0KM = "1"
const VEHICLE_TYPE_2NDHAND = "2"
const PRODUCT_TYPE_SIGORTALI = "2"
const PRODUCT_TYPE_SIGORTASIZ = "1"

let queryStringAmount:any = ""
let queryStringVade:any = ""

const getQueryStringValue = (paramName, defaultValue) => {
  const queryParams = new URLSearchParams(window.location.search)
  if (queryParams){
    let retVal:any = queryParams.get(paramName)
    if (retVal){
      if (paramName === "tutar"){
        queryStringAmount = (retVal * 1)
        return isNaN(retVal) ? "" : (retVal * 1)
      } else if (paramName === "vade"){
        queryStringVade = (retVal * 1)
        return isNaN(retVal) ? "" : (retVal * 1)
      } else if (paramName === "urun"){
        return (retVal === PRODUCT_TYPE_SIGORTASIZ) ? 'H' : 'E'
      }
      return retVal
    }

    return defaultValue
  }
}

const CalculateForm = ({cid}) => {
  const history = useHistory()
  const dispatch = useAppDispatch()
  const [productMinsMaxs, setProductMinsMaxs] = useState({
    minVade: 1,
    maxVade: 60,
    maxAmount: 150000
  })

  const [aylikOdeme, setAylikOdeme] = useState(0)
  const [totalPaymentAmt, setTotalPaymentAmt] = useState(0)
  const [faizOrani, setFaizOrani] = useState(0)
  const [yearlyInterestRate, setYearlyInterestRate] = useState("")
  const [amount, setAmount] = useState(() => getQueryStringValue("tutar", 150000))
  const [tasitDegeri, setTasitDegeri] = useState(0)
  const [vade, setVade] = useState(() => getQueryStringValue("vade", 36))
  const [sigorta, setSigorta] = useState(() => getQueryStringValue("urun", cid === "motosiklet" ? "H" : "E"))
  const [aracDurumu, setAracDurumu] = useState(() => getQueryStringValue("arac-tipi", VEHICLE_TYPE_0KM))
  const [showSlider, setShowSlider] = useState(false)
  const [amountChangedByUser, setAmountChangedByUser] = useState(false)
  const [vadeChangedByUser, setVadeChangedByUser] = useState(false)
  const [error, setError] = useState('')

  const [getProductInfoService, { isLoading }] = useGetProductInfoMutation()
  const [startApplicationService] = useStartApplicationMutation()
  const [productDetail, setProductDetail] = useState({})

  const getProductInfo = useCallback(() => {
    getProductInfoService({
      urunTip: sigorta === "E" ? PRODUCT_TYPE_SIGORTALI : PRODUCT_TYPE_SIGORTASIZ,
      aracTipi: aracDurumu,
      cid: cid
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setProductDetail(payload)
          setProductMinsMaxs({
            ...productMinsMaxs,
            minVade: payload.minVadeTl,
            maxVade: payload.maxVadeTl,
            maxAmount: parseInt(payload.maxTutar)
          })

          if (amountChangedByUser || vadeChangedByUser){
            return
          }
          
          if (queryStringAmount && queryStringVade) {
            const isAmountValid = 
              !isNaN(queryStringAmount) && 
              parseInt(queryStringAmount) >= parseInt(payload.minTutar) && 
              parseInt(queryStringAmount) <= parseInt(payload.maxTutar)

            const isVadeValid =
              !isNaN(queryStringVade) &&
              parseInt(queryStringVade) >= payload.minVadeTl &&
              parseInt(queryStringVade) <= payload.maxVadeTl

            let tmpAmount = productMinsMaxs.maxAmount
            let tmpVade = productMinsMaxs.maxVade

            if (isAmountValid) {
              tmpAmount = parseInt(queryStringAmount)
            }
            if (isVadeValid) {
              tmpVade = parseInt(queryStringVade)
            }

            setAmount(tmpAmount)
            setVade(tmpVade)
            setShowSlider(true)
          } else {
            setShowSlider(true)
          }
        }
      })
  }, [sigorta, aracDurumu, cid])

  const calculatePayment = () => {
    let result = {
      aylikOdeme: 0,
      faizOrani: 0,
      yearlyInterestRate: 0,
      totalPaymentAmt: 0
    }

    if (Object.keys(productDetail).length !== 0) {
      result = calculateMonthlyPayment(amount, vade, productDetail)
    }

    if (result) {
      setAylikOdeme(isNaN(result.aylikOdeme) ? 0 : result.aylikOdeme)
      setTotalPaymentAmt(isNaN(result.totalPaymentAmt) ? 0 : result.totalPaymentAmt)
      setFaizOrani(result.faizOrani)
      setYearlyInterestRate(
        isNaN(result.aylikOdeme) ? "% 0" : "% " + result.yearlyInterestRate.toFixed(4)
      )
      setShowSlider(true)
    }
  }

  const handleChange = useCallback((e) => {
    const name = e.target.name
    const value = e.target.value

    if (name === "amount" && value) {
      let eventValue = value === "" ? null : value.replace(/\./g, "").replace(/[^0-9]+/, "")
      let amt = parseInt(eventValue)
      setAmount(amt)
      setAmountChangedByUser(true)
    }

    if (name === "tasitDegeri" && value) {
      let eventValue = value === "" ? null : value.replace(/\./g, "").replace(/[^0-9]+/, "")
      let amt = parseInt(eventValue)
      setTasitDegeri(amt)
    }
  }, [])

  const handleSliderChange = useCallback((e?: any, data?: number) => {
    if (data) {
      setVade(data)
      setVadeChangedByUser(true)
    }
  }, [])

  const handleSigortaChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    if (value === "E") {
      setSigorta("E")
    } else {
      setSigorta("H")
    }
  }, [])

  const handleAracDurumuChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setAracDurumu(value)
  }, [])

  // Sigorta ve Araç Durumu seçimi sonrası tetiklenen useEffect
  useEffect(() => {
    if (sigorta && aracDurumu) {
      getProductInfo()
    }
  }, [sigorta, aracDurumu, cid])

  // Tutar, Vade ya da ürün detayları güncellendiğinde tetiklenen hesaplama useEffecti
  useEffect(() => {
    if (amount && vade && Object.keys(productDetail).length !== 0) {
      calculatePayment()
    }
  }, [amount, vade, productDetail])

  const handleSubmit = useCallback((e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
    if (amount > 0 && vade > 0) {
      dispatch(
        setCustomerData({
          tutar: amount,
          vade: vade,
          sigorta: sigorta,
          aracDurumu: aracDurumu
        })
      )
      startApplicationService({
        krediTutari: amount,
        tasitDegeri: tasitDegeri,
        krediVade: vade,
        urunTip: sigorta === "E" ? PRODUCT_TYPE_SIGORTALI : PRODUCT_TYPE_SIGORTASIZ,
        aracTipi: aracDurumu,
        cid: cid
      })
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            history.push({
              pathname: "/details/initialinfo"
            })
          } else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
    }
  },[dispatch, history, amount, vade, sigorta, aracDurumu, tasitDegeri])

  let showSigortaGroup = true
  let formHeaderText = 'Taşıt Kredini Hesapla'
  if (cid === "motosiklet") {
    formHeaderText = 'Motosiklet Kredini Hesapla'
    showSigortaGroup = false
  } else if (cid === "cevredostu") {
    formHeaderText = "Çevre Dostu Taşıt Kredini Hesapla"
  }

  return (
    <Page>
      <Form onChange={handleChange} onSubmit={handleSubmit}>
        <FormMessage className="form-msg-error" error={error}></FormMessage>
        <Panel hasFooter connected={false} loading={isLoading}>
          <Panel.Body>
            <Element type="h1" className="bapp-panel-body-card-description-landing">
              {formHeaderText}
            </Element>
            <Amount
              id="amount"
              name="amount"
              label="Kredi Tutarı"
              value={{ amount: amount, currency: "888" }}
              withDecimalPart={false}
              withCurrency={false}
              maxLength={9}
              allowDecimals={false}
              allowNegativeValue={false}
              align="left"
              placeholder="Lütfen kredi tutarı giriniz."
            />
            <Amount
              id="tasitDegeri"
              name="tasitDegeri"
              label="Taşıt Değeri"
              value={{ amount: tasitDegeri, currency: "888" }}
              withDecimalPart={false}
              withCurrency={false}
              maxLength={9}
              allowDecimals={false}
              allowNegativeValue={false}
              align="left"
              placeholder="Lütfen taşıt değeri giriniz."
            />
            {showSigortaGroup && 
            <RadioGroup
              value={sigorta}
              name="rdSigorta"
              onChange={handleSigortaChange}
              block={false}>
              <Radio label="Sigortalı" name="rdSigorta" value="E" />
              <Radio label="Sigortasız" name="rdSigorta" value="H" />
            </RadioGroup>}
            <RadioGroup
              value={aracDurumu}
              name="rdAracDurumu"
              onChange={handleAracDurumuChange}
              block={false}>
              <Radio label="0 Km" name="rdAracDurumu" value={VEHICLE_TYPE_0KM} />
              <Radio label="2. El" name="rdAracDurumu" value={VEHICLE_TYPE_2NDHAND} />
            </RadioGroup>
            {showSlider && (
              <Slider
                label="Vade"
                name="vadeSlider"
                min={productMinsMaxs.minVade}
                max={productMinsMaxs.maxVade}
                step={1}
                defaultValue={vade}
                valueTitle="Ay"
                included
                onChange={handleSliderChange}
              />
            )}
            <CalculationDetail
              aylikOdeme={aylikOdeme}
              totalPaymentAmt={totalPaymentAmt}
              faizOrani={faizOrani}
              yearlyInterestRate={yearlyInterestRate}
            />
          </Panel.Body>
          <Panel.Footer>
            <Button
              text="Hemen Başvur"
              type="submit"
              className="apply-button"
              fetching={isLoading}
              disabled={isLoading}
            />
          </Panel.Footer>
        </Panel>
      </Form>
    </Page>
  )
}

export default CalculateForm
